import {FacingMode} from 'enums';

import {KeyStorage} from './Storage';

const STORAGE_KEY = 'ezs-media-devices';

export type MediaDevicesStorageData = {
    [key in MediaDeviceKind]?: string
} & {
    facingMode?: FacingMode
}

export const MediaDevicesStorage = new KeyStorage<MediaDevicesStorageData>(STORAGE_KEY, {base64: true});
